import { render, staticRenderFns } from "./CourseUsers.html?vue&type=template&id=02cffde2&scoped=true&external"
import script from "./CourseUsers.vue?vue&type=script&lang=js"
export * from "./CourseUsers.vue?vue&type=script&lang=js"
import style0 from "./CourseUsers.scss?vue&type=style&index=0&id=02cffde2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cffde2",
  null
  
)

export default component.exports